module.exports = __webpack_public_path__ + "static/img/team_1.ef7c622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team_1.png
// module id = sJ5E
// module chunks = 1